import React from "react";
import { FaHospital, FaFileMedical, FaUserInjured } from "react-icons/fa6";
import banner7 from "../assets/banner7.jpg";

export default function HMIS() {
  const features = [
    { icon: <FaHospital size={20} className="text-primary" />, text: "Centralized patient record management for all hospital departments." },
    { icon: <FaFileMedical size={20} className="text-primary" />, text: "Appointment, billing, pharmacy, and laboratory service integration." },
    { icon: <FaUserInjured size={20} className="text-primary" />, text: "Real-time data access to improve patient care and operational efficiency." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Hospital Management Information System (HMIS)</h2>
          <p className="section-copy">
            Design and implementation of integrated healthcare information systems for managing patient records, appointments, billing, pharmacy, laboratory services, and reporting.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner7} alt="HMIS" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Ensures data integrity, real-time access, and interoperability across hospital departments, improving workflow efficiency and patient care coordination.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Assess hospital processes and workflows for system integration.</li>
            <li>Configure modules for patient management, billing, lab, and pharmacy.</li>
            <li>Ensure secure and real-time access to departmental data.</li>
            <li>Train staff and monitor performance to ensure adoption and efficiency.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}